
const DID_NOT_RECONCILE = 'didNotReconcile';
const NEVER_RECONCILED = 'neverReconciled';
const RECONCILED = 'reconciled';
const RECONCILIATION_NOT_ANSWERED = 'reconciliationNotAnswered';

export const reconcileAptcTypes = {
    DID_NOT_RECONCILE,
    NEVER_RECONCILED,
    RECONCILED,
    RECONCILIATION_NOT_ANSWERED
};